import { Inject, Injectable } from "@angular/core";
import { Helpers } from '../utilities/helpers';

@Injectable()
export class RedirectURLService {

    setData(data: string): void {
        try {
            Helpers.setSessionStorage("cmrs.redirectUrl", data);
        }
        catch (err) {
            console.log(err);
        }        
    }

    getData(): string | null {
        try {
            let url = Helpers.getSessionStorage("cmrs.redirectUrl");
            if (!url || url == "")
                return null;

            return url;
        }
        catch (err) {
            console.log(err);
            return null;
        }        
    }
}